import { render } from "./MemberGroupTable.vue?vue&type=template&id=192153dc"
import script from "./MemberGroupTable.vue?vue&type=script&lang=js"
export * from "./MemberGroupTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__